import gql from "graphql-tag";

const MARK_AS_SEEN = gql`
  mutation markAsSeen($notificationId: ID!) {
    markAsSeen(notificationId: $notificationId)
  }
`;

export default MARK_AS_SEEN;
